import { Container, Row, Col } from "react-bootstrap";
import { usePrefersReducedMotion } from '../lib/usePrefersReducedMotion';
import TrackVisibility from 'react-on-screen';
import 'animate.css';

const products = [
  {
    name: "StableSite",
    blurb: "Custom WordPress systems for stables, fleets, catalogs, and any operation managing structured records."
  },
  {
    name: "StableShare",
    blurb: "Private member and owner portals with role-based access and tokenized-ownership-ready architecture."
  },
  {
    name: "HaulDesk",
    blurb: "Multi-tenant SaaS for owner-operators and small fleets. Drivers, loads, PODs, invoices, compliance — one platform."
  }
];

export const SystemBuilderSection = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <section className="system-builder" id="systems" aria-labelledby="systems-heading">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            <TrackVisibility once>
              {({ isVisible }) => (
                <div className={prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeIn" : "pre-reveal")}>
                  <h2 id="systems-heading">We don't just build websites, we build systems.</h2>
                  <div className="system-builder-body">
                    <p>
                      Most agencies build brochures with a contact form. We build the tools your business actually runs on.
                    </p>
                    <p>
                      When <strong>Sackatoga Stable</strong> came to us, they didn't just need a new site — they needed a way to add horses, log races, calculate career stats, and keep their ownership group informed without exporting CSVs and emailing PDFs around. So I built <strong>StableSite</strong>: a custom WordPress system with 75+ shortcodes, auto-calculating career statistics, and a private ownership portal in <strong>StableShare</strong>.
                    </p>
                    <p>
                      When <strong>FTR Trucking</strong> started up, they didn't just need a website — they needed a way to manage drivers, loads, broker info packets, POD photos coming in over text, and invoices that actually match the job. So we started building <strong>HaulDesk</strong>: a SaaS platform built specifically for owner-operators and small fleets.
                    </p>
                    <p>
                      Same pattern, different industry. Listen first. Find the operational pain. Build the tools that make the work easier and your business more profitable. Your website is the front door — the real value is in what's behind it.
                    </p>
                  </div>
                </div>
              )}
            </TrackVisibility>

            <Row className="system-builder-products">
              {products.map((p, i) => (
                <Col xs={12} md={4} key={p.name}>
                  <TrackVisibility once>
                    {({ isVisible }) => (
                      <div className={`product-card ${prefersReducedMotion ? "" : (isVisible ? "animate__animated animate__fadeInUp" : "pre-reveal")}`} style={{ animationDelay: `${i * 100}ms` }}>
                        <h3>{p.name}</h3>
                        <p>{p.blurb}</p>
                      </div>
                    )}
                  </TrackVisibility>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
